import React from "react";

import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import TransitionHeader from "../ui/TransitionHeader";

import NextTasks from "./NextTasks";
import TransitionDetailsCard from "./TransitionDetails/TransitionDetailsCard";

import styles from "./TransitionNextTasksAndDetails.module.css";

const TransitionNextTasksAndDetails: React.FC = () => {
  const { transitionId } = useParams<{ transitionId: string }>();

  return (
    <div>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Stack spacing={2} className={styles.flexColumn}>
          <NextTasks />
        </Stack>
        <Stack spacing={0} className={styles.flexColumn}>
          <TransitionHeader title="Transition Details" />
          {transitionId && (
            <TransitionDetailsCard transitionId={transitionId} />
          )}
        </Stack>
      </Stack>
    </div>
  );
};

export default TransitionNextTasksAndDetails;
